export default __webpack_public_path__ + "static/media/iphone_transparent.bd762595.webp";